import React from 'react';

const Login = () => (
  <section className="py-10 grid place-items-center">
    <div className="w-full max-w-md p-6 rounded-2xl border shadow-soft bg-white">
      <h1 className="text-2xl font-bold">Login</h1>
      <div className="mt-4 grid gap-3">
        <input className="border rounded-md p-3" placeholder="Email" />
        <input type="password" className="border rounded-md p-3" placeholder="Password" />
        <button className="bg-brand-primary text-white rounded-md px-5 py-3">Login</button>
      </div>
    </div>
  </section>
);

export default Login;
